import { render, staticRenderFns } from "./StripeDeposit.vue?vue&type=template&id=83877af8"
import script from "./StripeDeposit.vue?vue&type=script&lang=js"
export * from "./StripeDeposit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports